import { types } from './mutations';

export default {
  setBreadcrumbsAction ({ commit }, args) {
    const items = args;
    commit(types.SET_ITEMS, items);
  },
};
